import { render, staticRenderFns } from "./AppToolbar.vue?vue&type=template&id=a2136bc8&scoped=true"
import script from "./AppToolbar.vue?vue&type=script&lang=js"
export * from "./AppToolbar.vue?vue&type=script&lang=js"
import style0 from "./AppToolbar.vue?vue&type=style&index=0&id=a2136bc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2136bc8",
  null
  
)

export default component.exports